import deposit_account_info from './deposit-account-info.json';

export default {
  deposits: {
    ...deposit_account_info,
  },
};
